module.exports = __webpack_public_path__ + "img/infoImg-2.fb8d52e9.jpg";